/* Nom d'un logement cliquable → ouvre sa fiche (raccourci Facturation).
   Navigation seule : le bouton ne porte aucun montant ni calcul. Le style
   hérite du texte parent (pas de changement de fond) ; seul un souligné
   discret signale le lien. */
import { ouvrirFicheLogement } from '../lib/goto-logement'

const STYLE_LIEN = {
  background: 'transparent',
  border: 'none',
  padding: 0,
  fontFamily: 'inherit',
  fontSize: 'inherit',
  fontWeight: 'inherit',
  color: 'inherit',
  cursor: 'pointer',
  textDecoration: 'underline',
  textDecorationColor: 'rgba(61,81,102,.35)',
  textUnderlineOffset: 2,
}

export default function NomLogementLien({ logementId, nom }) {
  return (
    <button
      type="button"
      onClick={() => ouvrirFicheLogement(logementId)}
      aria-label={`Ouvrir la fiche de ${nom}`}
      title="Ouvrir la fiche du logement"
      data-testid={`fact-fiche-link-${logementId}`}
      style={STYLE_LIEN}
    >
      {nom}
    </button>
  )
}
